import { Injectable } from "@angular/core";
import { CustomerSettingDto, CustomerSettingsService } from "src/shared/service-proxies/service-proxies";
import { LocalStorageService } from "./local-storage.service";
import { PageHelperService } from "../helpers/page-helper.service";
import { Observable } from "rxjs";

@Injectable()
export class CustomerSettings {
    constructor (private customerSettingsService: CustomerSettingsService, private localStorageService: LocalStorageService, private pageHelperService: PageHelperService){
    }

    getCustomerSettings(customerId: string): Observable<CustomerSettingDto[]> {
        return this.customerSettingsService.getCustomerUISettings(customerId);
    }

    setCustomerSettings(settings: CustomerSettingDto[]) {
        this.localStorageService.setItem("customer-ui-settings", JSON.stringify(settings));
    }

    loadCustomerSettings(customerId: string) {
        this.customerSettingsService.getCustomerUISettings(customerId).subscribe(data => {
            this.localStorageService.setItem("customer-ui-settings", JSON.stringify(data));
        });
    }

    getUISetting(settingName: string, defaultValue?: string): string {
        try {
            var items: CustomerSettingDto[] = JSON.parse(this.localStorageService.getItem("customer-ui-settings"));
            var item = items.find(d => d.key == settingName);
            return item != null ? item.settingValue : defaultValue;
        } catch (e) {
            return defaultValue;
        }
    }
}
